import { Component } from '@angular/core';

@Component({
  selector: 'icon-music-stop',
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-x">
        <circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/>
    </svg>
  `,
  styles: `
    svg{
        cursor: pointer;
        stroke: #2A4B5A;
        -webkit-transition: all .15s linear;
        -moz-transition: all .15s linear;
        -o-transition: all .15s linear;
        transition: all .15s linear;
        
        path{
            stroke: #2A4B5A;
            -webkit-transition: all .15s linear;
            -moz-transition: all .15s linear;
            -o-transition: all .15s linear;
            transition: all .15s linear;
        }
        circle{
            stroke: #2A4B5A;
            -webkit-transition: all .15s linear;
            -moz-transition: all .15s linear;
            -o-transition: all .15s linear;
            transition: all .15s linear;
        }

        &:hover{
            stroke: red;
            path{
                stroke: red;
            }
            circle{
                stroke: red;
            }
        }
    }
  `
})
export class StopMusicIconComponent {

}
